import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { ReactComponent as CalenderIcon } from "icons/calenderLargeIcon.svg";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./styles.module.scss";

export function CustomDatePicker({
  title,
  changeHandler,
  selectsEnd,
  selectsStart,
  startDate,
  endDate,
  minDate,
  maxDate,
  disabled,
  value,
}: any) {
  const [selectedDate, setSelectedDate] = useState(null);

  return (
    <DatePicker
      selected={value}
      // selectsEnd={selectsEnd}
      // selectsStart={selectsStart}
      // startDate={startDate}
      // endDate={endDate}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      onChange={(date: any) => {
        setSelectedDate(date);
        changeHandler(title, date);
      }}
      dateFormat="MMM d, yyyy"
      customInput={
        <CustomDatePickerInput
          value={selectedDate}
          onClick={() => console.log("----")}
          disabled={disabled}
        />
      }
    />
  );
}

const CustomDatePickerInput = ({ value, onClick, disabled }: any) => {
  const activeDisplayValue = value ? value : "Select Date";
  const placeHolderClass = value ? "" : styles.placeholder;
  return (
    <button
      type="button"
      className={styles.customDateInput}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={placeHolderClass}>{activeDisplayValue}</span>
      <CalenderIcon />
    </button>
  );
};
